import { ca } from '@cian/analytics';

export function trackClickOnBanner() {
  ca('eventSite', {
    action: 'click',
    category: 'Listing',
    label: 'country_builders_banner',
    name: 'oldevent',
  });
}

export function trackScrollOnBanner() {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'Listing',
    label: 'country_builders_banner',
    name: 'oldevent',
  });
}
